import Vue from "vue";
import Router from "vue-router";
import { isLogged, notHasPermissions } from "../utils/auth";
// import { ROUTER_DEFAULT_CONFIG } from "Config/index";
// import { routerBeforeEachFunc } from "Config/interceptors/router";

Vue.use(Router);

import DashboardLayout from "src/pages/Dashboard/Layout/DashboardLayout.vue";
// GeneralViews
import NotFound from "src/pages/GeneralViews/NotFoundPage.vue";
// Dashboard pages
import Overview from "src/pages/Dashboard/Dashboard/Overview.vue";
// import Stats from 'src/pages/Dashboard/Dashboard/Stats.vue'

import Login from "src/pages/Dashboard/Pages/Login2.vue";
import verifyMail from "src/pages/Dashboard/Pages/verifyMail.vue";
// import Register from 'src/pages/Dashboard/Pages/Register.vue'
import Register from "src/pages/Dashboard/Pages/Register2.vue";
import RegisterFamily from "src/pages/Dashboard/Pages/RegisterFamily.vue";
import RegisterAnnual from "src/pages/Dashboard/Pages/RegisterAnnual.vue";
import RegisterCoaching from "src/pages/Dashboard/Pages/RegisterCoaching.vue";
import ResetPassword from "src/pages/Dashboard/Pages/ResetPassword.vue";
import Lock from "src/pages/Dashboard/Pages/Lock.vue";
import Logout from "src/views/pages/logout";

import VueRouter from "vue-router";

import { localization } from 'src/mixins/mixins.js';

let loginPage = {
  path: "/login",
  name: "Login",
  component: Login
};

let verifyMailPage = {
  path: "/verifyMail",
  name: "verifyMail",
  component: verifyMail
};

let invitation = {
  name: "invitation",
  path: "/invitation/:id/:title",
  component: () => import("@/views/contacts/invitation.vue")
};
let registerPage = {
  path: "/register-basic/:contact?/:team?/:token?",
  name: "Register",
  component: Register
};
let registerFamilyPage = {
  path: "/register-family/:contact?/:team?/:token?",
  name: "Register Family",
  component: RegisterFamily
};
let registerAnnualPage = {
  path: "/register-professional/:contact?/:team?/:token?",
  name: "Register Annual",
  component: RegisterAnnual
};
let registerCoachingPage = {
  path: "/register-coaching/:contact?/:team?/:token?",
  name: "Register Annual",
  component: RegisterCoaching
};

let resetPasswordPage = {
  path: "/reset-password/:token",
  name: "ResetPassword",
  component: ResetPassword
};

let lockPage = {
  path: "/lock",
  name: "Lock",
  component: Lock
};

const router = new VueRouter({
  routes: configRoutes(), // short for routes: routes
  mode: "history",
  linkActiveClass: "active"
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    !isLogged()
      ? next({ path: "/login", params: { nextUrl: to.fullPath } })
      : next();
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  // scroll to top when rout change
  window.scrollTo(0, 0);
});

function configRoutes() {
  return [
    {
      path: "/",
      component: DashboardLayout,
      redirect: "/new-theme/profile",
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "/overview",
          name: localization("Home"),
          component: Overview
        },
        {
          path: "/logout",
          name: localization("logout"),
          component: Logout
        },
        {
          name: localization("Personal Learning Profile"),
          path: "/profile/",
          component: () => import("src/views/users/show")
        },
        {
          // Edit user data
          name: localization("Edit Profile"),
          path: "edit-user/:id?",
          meta: true,
          component: () => import("src/views/users/edit")
        },
        {
          // Edit user data
          name: localization("Edit Profile"),
          path: "/sync-data",
          meta: true,
          component: () => import("src/views/users/edit")
        },
        {
          // view user data from users table
          name: localization("User Profile"),
          path: "/user-profile/:id",

          component: () => import("src/views/users/ViewUserProfile")
        },
        // Print User Tasks
        {
          // view user data from users table
          name: localization("User Tasks"),
          path: "/user-profile/:id/user-tasks",
          component: () => import("src/views/users/PrintUserTasks")
        },
        {
          // view user data from users table
          name: localization("User Profile"),
          path: "/user-details/:id",
          meta: true,
          component: () => import("src/views/users/showUserDetails.vue")
        },
        {
          name: localization("Use Your Patterns"),
          // name: "Show Task",
          path: "edit-task/:id?",
          meta: true,
          component: () => import("src/views/tasks/edit")
        },
        {
          name: localization("Attributes"),
          path: "attributes",
          component: () => import("src/views/attributes/index")
        },
        {
          name: localization("Team Statements"),
          path: "team-statements",
          component: () => import("src/views/team-statements/index")
        },
        {
          name: localization("Statements Questions"),
          path: "statements-questions",
          component: () => import("src/views/statements-questions/index")
        },
        {
          name: localization("Words"),
          path: "words",
          component: () => import("src/views/words/index")
        },
        //// Localization
        {
          name: localization("Localization"),
          path: "localization",
          component: () => import("src/views/localization/index")
        },
        {
          name: localization("User Categories"),
          path: "user-categories",
          component: () => import("src/views/user-categories/index")
        },
        {
          name: localization("User Categories Details"),
          path: "user-categories/:id",
          component: () => import("src/views/user-categories/show")
        },
        {
          name: localization("Edit Localization"),
          path: "localization/:id",
          meta: true,
          component: () => import("src/views/localization/show")
        },
        {
          name: localization("Use Your Patterns"),
          path: "tasks/:id?",
          component: () => import("src/views/tasks/index")
        },
        // Use Your Patterns -- At Work Page
        {
          name: localization("At Work"),
          path: "at-work/:id?",
          component: () => import("src/views/tasks-at-work/index")
        },
        {
          name: localization("At Work Details"),
          path: "edit-at-work-task/:id?",
          meta: true,
          component: () => import("src/views/tasks-at-work/edit")
        },
        // Use Your Patterns -- Career Match Page
        {
          name: localization("Career Match"),
          path: "career-match/:id?",
          component: () => import("src/views/tasks-career-match/index")
        },
        {
          name: localization("Career Match Details"),
          path: "edit-career-match-task/:id?",
          meta: true,
          component: () => import("src/views/tasks-career-match/edit")
        },
        {
          name: localization("Family Members"),
          path: "family-members",
          component: () => import("src/views/family-members/index")
        },
        {
          name: localization("Families"),
          path: "families",
          component: () => import("src/views/families/index")
        },
        {
          name: localization("Family Details"),
          path: "families/:id",
          component: () => import("src/views/families/show")
        },
        {
          name: localization("Family Member Profile"),
          path: "families/family-profile/:id",
          component: () => import("src/views/families/family-profile")
        },
        // start career-statements
        {
          name: localization("Career Statements"),
          path: "career-statements",
          component: () => import("src/views/career-statements/index")
        },
        {
          name: localization("Career Statements Questions"),
          path: "career-statements-questions",
          component: () => import("src/views/career-statements-questions/index")
        },
        {
          name: localization("Career Match Questions"),
          path: "career-match-questions",
          component: () => import("src/views/career-questions/index")
        },
        {
          name: localization("Career Strategy Details"),
          path: "career-strategies/:id",
          component: () => import("src/views/career-strategies/show")
        },
        {
          name: localization("Career Strategies"),
          path: "career-strategies",
          component: () => import("src/views/career-strategies/index")
        },
        // end career-statements
        {
          name: localization("Questions"),
          path: "questions",
          component: () => import("src/views/questionnaire/index")
        },
        {
          name: localization("Question"),
          path: "questions/:id",
          meta: true,
          component: () => import("src/views/questionnaire/show")
        },
        {
          name: "LCI",
          path: "edit-questionnaire/",
          meta: true,
          component: () => import("src/views/questionnaire/questionnaire")
        },
        {
          name: "User LCI",
          path: "edit-questionnaire/:id",
          meta: true,
          component: () => import("src/views/questionnaire/questionnaire")
        },
        {
          name: "LCI",
          path: "before",
          component: () => import("src/views/questionnaire/before")
        },

        {
          name: localization("Strategies"),
          path: "strategies",
          component: () => import("src/views/strategies/index")
        },
        {
          name: localization("Strategy"),
          path: "Strategy/:id",
          meta: true,
          component: () => import("src/views/strategies/show")
        },
        {
          name: localization("Topics"),
          path: "topics",
          component: () => import("src/views/topics/index")
        },
        {
          name: localization("Topic"),
          path: "topic/:id",
          meta: true,
          component: () => import("src/views/topics/show")
        },
        {
          name: localization("versions"),
          path: "topic/:id/:version_id",
          meta: true,
          component: () => import("src/views/topics/show-versions")
        },
        {
          name: localization("Data Cards"),
          path: "data_cards",
          component: () => import("src/views/data_cards/index")
        },
        {
          name: localization("Data Card Details"),
          path: "data_cards/:id",
          component: () => import("src/views/data_cards/show")
        },
        {
          name: localization("Cards Topics"),
          path: "topics_card",
          component: () => import("src/views/topics_card/index")
        },
        {
          name: localization("Tasks"),
          path: "topics/:id/topics-tasks",
          meta: true,
          component: () => import("src/views/topics/topics-tasks")
        },

        {
          name: localization("Users"),
          path: "users",
          component: () => import("src/views/users/index")
        },
        {
          name: localization("Institutions"),
          path: "institution",
          component: () => import("src/views/institution/index")
        },
        {
          name: localization("Institution"),
          path: "show-institution/:id",
          meta: true,
          component: () => import("src/views/institution/show")
        },
        {
          name: localization("User Profile"),
          path: "show-institution/user-profile/:id",
          meta: true,

          component: () => import("src/views/users/ViewUserProfile")
        },
        {
          name: localization("Logs"),
          path: "logs",
          component: () => import("src/views/logs/index")
        },

        {
          name: localization("Roles"),
          path: "roles",
          component: () => import("src/views/permission/index")
        },
        {
          name: localization("User Permissions"),
          path: "permissions/:id",
          meta: true,
          component: () => import("src/views/permission/show")
        },
        {
          name: localization("Management"),
          path: "management",
          component: () => import("src/views/managment/index")
        },
        {
          name: localization("Languages"),
          path: "languages",
          component: () => import("src/views/language/index")
        },
        {
          name: localization("Edit Content"),
          path: "page/:id",
          meta: true,
          component: () => import("src/views/cms/edit")
        },
        {
          name: localization("Contacts"),
          path: "contacts",
          component: () => import("src/views/contacts/index")
        },

        {
          name: localization("Groups"),
          path: "groups",
          component: () => import("src/views/groups/index")
        },
        {
          name: localization("Website CMS"),
          path: "cms",
          component: () => import("src/views/cms/index")
        },
        {
          name: localization("User Dashboard"),
          path: "user-dashboard",
          component: () => import("src/views/user-dashboard/UserDashboard")
        },
        {
          name: localization("Teams"),
          path: "teams",
          component: () => import("src/views/my-teams/MyTeams")
        },
        {
          name: localization("Team Details"),
          path: "teams/:id",
          component: () => import("src/views/my-teams/TeamDetails")
        },
        {
          name: localization("Introduce Yourself"),
          path: "introduce-yourself",
          component: () => import("src/views/introducing-yourself/index")
        },
        {
          name: localization("Building The Team"),
          path: "building-team",
          component: () => import("src/views/building-team/index")
        },
        {
          name: localization("Working Together"),
          path: "working-together",
          component: () => import("src/views/working-together/index")
        },
        {
          name: localization("Tackling Project"),
          path: "tackling-project",
          component: () => import("src/views/talking-project/index")
        },
        {
          name: localization("Tackling Project"),
          path: "tackling-project/:id",
          component: () => import("src/views/talking-project/show-team-task")
        },
        {
          name: localization("Task Categories"),
          path: "task-categories",
          component: () => import("src/views/task-category/index")
        },
        {
          name: localization("Category Tasks"),
          path: "task-categories/:id",
          component: () => import("src/views/task-category/show")
        },
        {
          name: localization("How Will the LCI Help You?"),
          path: "lci-help-you",
          component: () => import("src/views/lci-help-you/index")
        },
        {
          name: localization("Videos"),
          path: "videos",
          component: () => import("src/views/videos/index")
        },
        {
          name: localization("My Dashboard"),
          path: "my-dashboard",
          component: () => import("src/views/my-dashboard/index")
        },
        // New Theme
        {
          name: localization("Instructions View"),
          path: "new-theme/instructions",
          component: () =>
            import("src/views/a-new-theme/lci-pages/InstructionsView.vue"),
          meta: { hideSidebar: true, hideNavbar: true }
        },
        {
          name: localization("Lci Questions"),
          path: "new-theme/questions/:id?",
          component: () =>
            import("src/views/a-new-theme/lci-pages/LciQuestions.vue"),
          meta: { hideSidebar: true, hideNavbar: true }
        },
        {
          name: localization("Profile View"),
          path: "new-theme/profile/:id?",
          component: () =>
            import("src/views/a-new-theme/profile/ProfileView.vue")
        },

        {
          name: localization("Personalize Your Profile"),
          path: "new-theme/personalize-profile/:id?",
          component: () =>
            import("src/views/a-new-theme/profile/PersonalizeProfile.vue")
        },
        {
          name: localization("Personalize Your Profile plp"),
          path: "new-theme/plp/:id?",
          component: () => import("src/views/a-new-theme/plp/PlpView.vue")
        },
        {
          name: localization("Contact View"),
          path: "new-theme/contacts",
          component: () =>
            import("src/views/a-new-theme/contacts/ContactView.vue")
        },
        {
          name: localization("All Tasks"),
          path: "new-theme/all-tasks",
          component: () => import("src/views/a-new-theme/tasks/AllTasks.vue")
        },
        {
          name: localization("Tasks View"),
          path: "new-theme/tasks",
          component: () => import("src/views/a-new-theme/tasks/TasksView.vue")
        },
        {
          name: localization("Task Details"),
          path: "new-theme/tasks/:task_id",
          meta: true,
          component: () => import("src/views/a-new-theme/tasks/TaskDetails.vue")
        },
        {
          name: localization("Work View"),
          path: "new-theme/at-work",
          component: () =>
            import("src/views/a-new-theme/tasks/at-work/WorkView.vue")
        },
        {
          name: localization("Work Details"),
          path: "new-theme/at-work/:task_id",
          component: () =>
            import("src/views/a-new-theme/tasks/at-work/WorkDetails.vue")
        },
        {
          name: localization("Career View"),
          path: "new-theme/career",
          component: () =>
            import("src/views/a-new-theme/tasks/career/CareerView.vue")
        },
        {
          name: localization("Teams View"),
          path: "new-theme/teams",
          component: () =>
            import("src/views/a-new-theme/teams/Teams.vue")
        },
        {
          name: localization("Team Details"),
          path: "new-theme/teams/:id",
          component: () =>
            import("src/views/a-new-theme/teams/TeamDetails.vue")
        },
        {
          name: localization("Groups List"),
          path: "new-theme/groups",
          component: () =>
            import("src/views/a-new-theme/groups/Groups.vue")
        },
        {
          name: localization("Group Details"),
          path: "new-theme/groups/:id",
          component: () =>
            import("src/views/a-new-theme/groups/GroupDetails.vue")
        },
        {
          name: localization("Build Team"),
          path: "new-theme/build-team",
          component: () =>
            import("src/views/a-new-theme/teams/BuildTeam.vue")
        },
        {
          name: localization("step-1"),
          path: "new-theme/build-team/step-1",
          component: () =>
            import("src/views/a-new-theme/teams/step-1.vue"),
          meta: { hideSidebar: true, hideNavbar: true }

        },
        {
          name: localization("step-2"),
          path: "new-theme/build-team/step-2",
          component: () =>
            import("src/views/a-new-theme/teams/step-2.vue"),
          meta: { hideSidebar: true, hideNavbar: true }
        },
        {
          name: localization("step-3"),
          path: "new-theme/build-team/step-3",
          component: () =>
            import("src/views/a-new-theme/teams/step-3.vue"),
          meta: { hideSidebar: true, hideNavbar: true }
        },
        {
          name: localization("step-4"),
          path: "new-theme/build-team/step-4/:id",
          component: () =>
            import("src/views/a-new-theme/teams/step-4.vue"),
          meta: { hideSidebar: true, hideNavbar: true }
        },
        {
          name: localization("Career Details"),
          path: "new-theme/career/:task_id",
          component: () =>
            import("src/views/a-new-theme/tasks/career/CareerDetails.vue")
        },
        {
          name: localization("Personal Work Profile (PWP)"),
          path: "new-theme/pwp",
          component: () =>
            import("src/views/a-new-theme/tasks/pwp/PwpCareer.vue"),
          meta: { hideNavbar: true }
        },
        {
          name: localization("Pwp Questions"),
          path: "new-theme/pwp-questions",
          component: () =>
            import("src/views/a-new-theme/tasks/pwp/PwpQuestions.vue"),
          meta: { hideSidebar: true, hideNavbar: true }
        },
        {
          name: localization("View Pwp Questions"),
          path: "new-theme/view-pwp-questions",
          component: () =>
            import("src/views/a-new-theme/tasks/pwp/PwpQuestions.vue"),
          meta: { hideSidebar: true, hideNavbar: true }
        },
      ]
    },
    {
      name: localization("Print Multiple Tasks"),
      path: "/printMultiTasks/:tasksId",
      component: () =>
        import("src/views/tasks/printTasksDetails.vue"),
      props: (route) => ({
        selectedTasks: route.params.tasksId ? route.params.tasksId.split(',') : []
      })
    },
    loginPage,
    invitation,
    verifyMailPage,
    registerPage,
    resetPasswordPage,
    registerFamilyPage,
    registerAnnualPage,
    registerCoachingPage,
    // lockPage,
    { path: "*", component: NotFound }
  ];
}

export default router;
